import {
  DemoRequestInterceptor,
  DemoResponseInterceptor,
} from "@/_old/features/demo";
import { BLOCKED_LEAGUES } from "@/_old/hooks/use-feature-flag/shared/use-league-not-permission";
import { isEnabledByEnvAndLeague } from "@/_old/hooks/use-feature-flag/utils";
import { cookieManager } from "@/_old/utils/cookie-manager";
import { InterceptorStatusCode } from "@/_old/utils/interceptor-status-code";
import { getAccessToken } from "@/core/components/auth/services/cookies";
import { createLoggerInterceptor } from "@/core/config/axios-logger";
import { wobaLogger } from "@/core/config/woba-logger";
import axios from "axios";

export const apiGateway = axios.create({
  baseURL: import.meta.env.VITE_API_GATEWAY_URL,
});

const actualDate = new Date();
const expirationDate = new Date(
  new Date(actualDate).setMonth(actualDate.getMonth() + 1),
);

apiGateway.interceptors.request.use((config) => {
  const userToken = getAccessToken();
  const urlParams = new URLSearchParams(window.location.search);

  const queryToken = urlParams.get("auth_token");

  const configToken = config.headers?.["auth-token"];

  if (queryToken) {
    cookieManager.set({
      cookieName: "u_token",
      value: queryToken,
      globally: true,
      expirationDate,
    });
  }

  if (!userToken && !queryToken) {
    // No longer setting last_url_path cookie - migration to query params
    // The redirect will be handled by modal-error-request component with query params
    throw new axios.Cancel("user not logged");
  }

  const token = configToken ? configToken : userToken || queryToken;

  // @ts-ignore
  config.headers = {
    ...config.headers,
    "Auth-token": token,
    Authorization: `Bearer ${token}`,
  };
  return config;
});

apiGateway.interceptors.response.use((response) => {
  const isUserFromBlockedLeague = isEnabledByEnvAndLeague(
    response.data.user?.leagues_id?.[0],
    BLOCKED_LEAGUES,
  );

  if (isUserFromBlockedLeague) {
    window.location.href = import.meta.env.VITE_PORTAL_URL;
    throw new axios.Cancel("user not authorized");
  }

  return response;
});

InterceptorStatusCode(apiGateway);

DemoRequestInterceptor(apiGateway);
DemoResponseInterceptor(apiGateway);

createLoggerInterceptor(apiGateway, wobaLogger);
